<template>
	<q-page class="full-height">
		<div class="row window-height justify-center items-center">
			<div class="col-sm-9 col-xl-8">
				<q-card class="full-width custom-shadow login-card" :class="changeContainerHeight">
					<div class="row height" :class="changeContainerHeight">
						<div class="col-4 q-px-lg container-login">
							<div class="row flex items-center full-height q-mx-lg">
								<div class="flex justify-center col-12 items-center logo-login">
									<img :src="logo" />
								</div>

								<div class="col-12" v-show="underMaintenance">
									<under-maintenance />
								</div>

								<div class="col-12 q-mt-xl" v-show="!underMaintenance">
									<login-form />
								</div>
							</div>
						</div>

						<div class="col-8" :style="{ borderLeft: '1px solid #e0e0e0' }">
							<div class="column relative-position full-height">
								<div class="col-auto" v-if="languages.length">
									<div class="row justify-end items-center q-col-gutter-x-md q-px-md q-py-sm">
										<span class="text-bold">{{ $t('language') }}</span>
										<div class="row q-col-gutter-x-sm">
											<img
												v-for="language in languages"
												v-bind:key="language.id"
												:src="`flags/${language.country_flag}.svg`"
												:alt="language.code"
												@click="changeIdiom(language.id)"
												role="img"
												class="cursor-pointer"
												:style="{
													width: '1.7rem',
													height: '1.7rem',
												}"
											/>
										</div>
									</div>
								</div>
								<div
									class="col q-pa-lg"
									:style="{
										width: '100%',
										height: '100%',
										objectPosition: 'center',
										backgroundImage: `url(${background})`,
										backgroundSize: 'cover',
										backgroundRepeat: 'no-repeat',
									}"
								>
									<div class="col-12">
										<h2 :class="login_dark_text ? 'text-black' : 'text-white'">
											{{ $t('welcome_to') }}<br /><strong>{{ $t('project_name') }}</strong>
										</h2>
									</div>
									<div class="col-12">
										<h6 :class="login_dark_text ? 'text-black' : 'text-white'">
											{{ $t('login_to_access_your_account') }}
										</h6>
									</div>
								</div>
								<div class="col-auto q-px-md q-py-sm">
									<div
										class="row justify-end items-center text-body1 text-weight-medium q-col-gutter-x-md"
										v-if="show_login_plataform_links"
									>
										<router-link
											:to="{ name: 'login_about' }"
											:class="login_dark_text ? 'text-black' : ''"
										>
											{{ $t('about') }}
										</router-link>

										<router-link
											:to="{ name: 'login_privacy_policy' }"
											:class="login_dark_text ? 'text-black' : ''"
										>
											{{ $t('privacy_policy') }}
										</router-link>

										<router-link
											:to="{ name: 'login_terms_and_conditions' }"
											:class="login_dark_text ? 'text-black' : ''"
										>
											{{ $t('terms_and_conditions') }}
										</router-link>

										<router-link
											v-if="support_use"
											:to="{ name: 'login_support' }"
											:class="login_dark_text ? 'text-black' : ''"
										>
											{{ $t('help') }}
										</router-link>
									</div>
								</div>
							</div>
						</div>
					</div>
				</q-card>
				<p class="text-caption text-center q-mt-xl">
					{{ $t('copyright') }} © {{ new Date().getFullYear() }} {{ projectName }} - Powered by
					<a href="https://take5.com.br" class="text-bold" target="_blank">Take 5 LMS</a> - v{{
						projectVersion
					}}.
					<br />
					{{ $t('this_website_is_best_viewed_in_google_chrome_and_mozilla_firefox') }}
				</p>
			</div>
		</div>
	</q-page>
</template>

<script>
import { mapGetters } from 'vuex'
import LoginForm from 'components/login/LoginForm'
import UnderMaintenance from 'components/login/UnderMaintenance'

export default {
	i18nOptions: { namespaces: ['custom', 'common', 'login'] },

	name: 'Login',

	data() {
		return {}
	},

	components: {
		'login-form': LoginForm,
		'under-maintenance': UnderMaintenance,
	},

	computed: {
		...mapGetters({
			background: 'params/background',
			languages: 'params/languages',
			logo_store: 'params/logo',
			logo_pt_store: 'params/logo_pt',
			logo_en_store: 'params/logo_en',
			logo_es_store: 'params/logo_es',
			logo_fr_store: 'params/logo_fr',
			login_dark_text: 'params/login_dark_text',
			show_login_plataform_links: 'params/show_login_plataform_links',
			id_user_language_selected: 'common/id_user_language_selected',
			under_maintenance: 'params/under_maintenance',
			support_use: 'params/support_use',
		}),

		projectName() {
			return process.env.PROJECT_NAME
		},

		projectVersion() {
			return process.env.APP_VERSION
		},

		changeContainerHeight() {
			if (this.$q.screen.height < 950) return 'height-80'
			else return 'height-70'
		},

		logo() {
			let language = this.$getLanguage(this.languages, this.id_user_language_selected)

			let code = ''

			if (language) {
				switch (language.code) {
					case 'es-ES':
						code = language.code.split('-')[0]
						break
					case 'fr-FR':
						code = language.code.split('-')[0]
						break
					default:
						code = language.code
						break
				}

				let logos = {
					logo_pt_store: this.logo_pt_store,
					logo_en_store: this.logo_en_store,
					logo_es_store: this.logo_es_store,
					logo_fr_store: this.logo_fr_store,
				}

				if (logos[`logo_${code.split('-')[0]}_store`] !== 'https://image.jpg')
					return logos[`logo_${code.split('-')[0]}_store`]
			}
			return this.logo_store
		},

		underMaintenance() {
			if (!this.under_maintenance || this.$route.name === 'maintenance_login') return false
			else return true
		},
	},

	methods: {
		changeIdiom(code) {
			let language = this.$getLanguage(this.languages, code)
			let code_str = ''

			switch (language.code) {
				case 'es-ES':
					code_str = language.code.split('-')[0]
					break
				case 'fr-FR':
					code_str = language.code.split('-')[0]
					break
				default:
					code_str = language.code
					break
			}

			import(`quasar/lang/${code_str}`).then((lang) => {
				this.$q.lang.set(lang.default)
			})

			if (language?.code)
				this.$changeWaLocal(language.code === 'pt-BR' ? 'br-pt' : language.code.toLowerCase())

			this.$store.dispatch('common/SET_LANGUAGE', [code])
		},
	},
}
</script>

<style lang="scss" scoped>
.container-login {
	margin-top: 8%;
	margin-bottom: 8%;
}
.logo-login {
	img {
		max-width: 70%;
	}
}
.login-card {
	border-radius: 1rem;
	.height-70 {
		min-height: 70vh;
	}
	.height-80 {
		min-height: 80vh;
	}
}
h2 {
	margin-top: 1rem;
	margin-bottom: 0;
}
h6 {
	margin-top: 0;
}
</style>
